module.exports = ".footer {\n  background: #eee;\n  padding-top: 1em;\n  padding-bottom: 1em;\n  color: black;\n  border-width: 1px 0 0 0;\n  border-color: #ddd;\n  border-style: solid; }\n  .footer a {\n    color: #333; }\n  @media (min-width: 768px) {\n  .footer {\n    padding-left: 100px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/com/footer/footer.scss
// module id = ./src/app/com/footer/footer.scss
// module chunks = main